/* eslint-disable @typescript-eslint/no-unused-expressions */
import { DatePickerField, InputField } from "@/components";

import { SelectField } from "@/components";
import { optionsRepeatEvery } from "@/partial/campaign/constant";
import { CampaignForm } from "@/partial/campaign/types";
import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from "react-hook-form";
import { Accordion } from "tvs-unified-lib/dist";
import { RadioRepeat, TitleRepeat } from "../../styles";
import { Controller } from "react-hook-form";

interface RepeatFormProps {
  control: Control<CampaignForm>;
  setValue: UseFormSetValue<CampaignForm>;
  getValues: UseFormGetValues<CampaignForm>;
  errors: FieldErrors<CampaignForm>;
  trigger: UseFormTrigger<CampaignForm>;
  watch: UseFormWatch<CampaignForm>;
}

export const RepeatForm = ({
  control,
  setValue,
  errors,
  trigger,
}: RepeatFormProps) => {
  return (
    <Accordion header="Yes" defaultOpen className="card-repeat">
      <TitleRepeat>Repeat Every</TitleRepeat>
      <SelectField
        name="repeat_frequency"
        label=""
        control={control}
        options={optionsRepeatEvery}
      />
      <TitleRepeat>Ends</TitleRepeat>
      <Controller
        control={control}
        name="repeat_end"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <>
            <RadioRepeat>
              <div>
                <input
                  type="radio"
                  id="repeat_end_never"
                  name="repeat_end"
                  value="repeat_end_never"
                  onChange={() => {
                    onChange("repeat_end_never");
                    setValue && setValue("repeat_end_never", true);
                    trigger("repeat_end_after_number_of_occurrences");
                    trigger("repeat_end_on");
                  }}
                  onBlur={onBlur}
                  checked={value === "repeat_end_never"}
                  ref={ref}
                />
                <label htmlFor="repeat_end_never">Never</label>
              </div>
            </RadioRepeat>
            <RadioRepeat $widthInput={60} $mt={20}>
              <div>
                <input
                  type="radio"
                  id="repeat_end_after_number_of_occurrences"
                  name="repeat_end"
                  value="repeat_end_after_number_of_occurrences"
                  onChange={() => {
                    onChange("repeat_end_after_number_of_occurrences");
                    setValue && setValue("repeat_end_never", false);
                    trigger("repeat_end_after_number_of_occurrences");
                    trigger("repeat_end_on");
                  }}
                  onBlur={onBlur}
                  checked={value === "repeat_end_after_number_of_occurrences"}
                />
                <label htmlFor="repeat_end_after_number_of_occurrences">
                  After{" "}
                  <InputField
                    name="repeat_end_after_number_of_occurrences"
                    control={control}
                    numberOnly
                  />{" "}
                  Occurrence
                </label>
              </div>
              {errors.repeat_end_after_number_of_occurrences && (
                <div className="theme-font-sm color-theme-red-500 theme-form-error-message">
                  {errors.repeat_end_after_number_of_occurrences.message}
                </div>
              )}
            </RadioRepeat>
            <RadioRepeat $mt={16}>
              <div>
                <input
                  type="radio"
                  id="repeat_end_on"
                  name="repeat_end"
                  value="repeat_end_on"
                  onChange={() => {
                    onChange("repeat_end_on");
                    setValue && setValue("repeat_end_never", false);
                    trigger("repeat_end_after_number_of_occurrences");
                    trigger("repeat_end_on");
                  }}
                  onBlur={onBlur}
                  checked={value === "repeat_end_on"}
                />
                <label htmlFor="repeat_end_on">
                  On <DatePickerField name="repeat_end_on" control={control} placeholder="Select Date" />
                </label>
              </div>
              {errors.repeat_end_on && (
                <div className="theme-font-sm color-theme-red-500 theme-form-error-message">
                  {errors.repeat_end_on.message}
                </div>
              )}
            </RadioRepeat>
          </>
        )}
      />
    </Accordion>
  );
};

export default RepeatForm;
